<template>
  <pilot-dialog :title="$t('pilotInfluencer')">
    <template #header-left>
      <button
        v-tooltip.bottom="{
          content: $t('back')
        }"
        class="pilot-tooltip-btn"
        @click="back"
      >
        <i class="isif isif-pilot-short-left" />
      </button>
    </template>
    <template #header-right>
      <button
        v-tooltip.bottom="{
          content: $t('close')
        }"
        class="pilot-tooltip-btn"
        @click="close"
      >
        <i class="isif isif-close" />
      </button>
    </template>
    <template #body>
      <div
        v-if="pilotInfluencer"
        class="pilot-influencer"
      >
        <div class="pilot-influencer__avatar">
          <img
            v-if="pilotInfluencer.portraitImage"
            :src="pilotInfluencer.portraitImage"
          >
          <i
            v-else
            class="isif isif-man"
          />
        </div>
        <div
          v-if="pilotInfluencer.name"
          class="pilot-influencer__title"
        >
          {{ pilotInfluencer.name }}
        </div>
      </div>
      <div class="pilot-tours">
        <div class="pilot-tours__title">
          {{ $t('pilotTourBy', { influencer: pilotInfluencer.name }) }}
        </div>
        <div
          v-horizontal-drag-scrolling="{
            startX: contentStartX,
            scrollLeft: contentScrollLeft,
            isMousedown: isContentMousedown
          }"
          class="pilot-tours__content"
        >
          <div
            v-for="item in pilotTours"
            :key="item.objectId"
            class="pilot-tour-card"
            :class="{ 'pilot-tour-card--active': item.objectId === tourId && isPilotPlaying }"
          >
            <div
              class="pilot-tour-card__thumbnail"
              @click="toPilotTour(item.objectId)"
            >
              <img
                v-if="item.pilotThumbnail || item.buildingThumbnail"
                :src="item.pilotThumbnail || item.buildingThumbnail"
              >
              <i
                v-else
                class="isif isif-man"
              />
            </div>
            <div class="pilot-tour-card__body">
              <div class="title">
                {{ item.name }}
              </div>
              <div class="subtitle">
                {{ item.ownerName }}
              </div>
            </div>
            <button
              class="pilot-tour-card__control-btn"
              @click="togglePilotPlayerStatus(item.objectId)"
            >
              <i
                class="isif isif-pilot-play"
                :class="{
                  'isif-pilot-pause': isPilotPlaying && item.objectId === tourId,
                }"
              />
            </button>
          </div>
        </div>
      </div>
    </template>
  </pilot-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import PilotDialog from './PilotDialog'

export default {
  name: 'PilotInfluencer',
  components: {
    PilotDialog
  },
  props: {
    pilotInfluencer: {
      type: Object,
      default () {
        return {}
      }
    },
    pilotTours: {
      type: Array,
      default () {
        return []
      }
    },
    tourId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      contentStartX: 0,
      contentScrollLeft: 0,
      isContentMousedown: false
    }
  },
  computed: {
    ...mapGetters([
      'isPilotPlaying'
    ])
  },
  methods: {
    back () {
      this.$emit('change-page', 'pilot-menu')
    },
    toPilotTour (tourId) {
      this.$emit('select-tour', tourId)
      this.$emit('show-player')
    },
    close () {
      this.$emit('close', 'pilot-influencer')
    },
    togglePilotPlayerStatus (tourId) {
      if (this.isPilotPlaying && this.tourId === tourId) {
        this.$emit('toggle-pilot-player-status')
      } else {
        this.$emit('select-tour', tourId)
        this.$emit('show-player')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'

.pilot-influencer {
  background-color: transparent
  width: 100%
  height: 85px
  display: flex
  align-items: center
  margin-bottom: 40px

  &__avatar {
    margin-right: 20px

    img {
      width: 85px
      height: 85px
      border-radius: 50%
      object-fit: cover
    }

    i {
      background-color: $white
      border-radius: 50%
      font-size: 85px
    }
  }

  &__title {
    color: $white
    font-weight: 700
    font-size: 16px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  }
}
</style>
